@if (sheetData) {
  <div class="dialogContainer">
    <div class="dialogHeader">
      <img
        class="closeButton"
        src="/images/closeIconWithoutBox.png"
        (click)="closeDialog()"
        />
      </div>
      <div class="dialogContent">
        <div>
          <div class="dialogContent">
            <app-dialog-input-title
              title="Sheet navn"
              [required]="true"
            ></app-dialog-input-title>
            <input type="text" class="Textbox" [(ngModel)]="sheetData.sheetName" />
          </div>
          <div>
            <div class="dialogContent">
              <app-dialog-input-title
                title="Sheet url"
                [required]="true"
              ></app-dialog-input-title>
              <input type="url" class="Textbox" [(ngModel)]="sheetData.sheetId" />
            </div>
            <div>
              <div class="dialogContent">
                <app-dialog-input-title
                  title="Brugere"
                  [required]="true"
                ></app-dialog-input-title>
                <select [(ngModel)]="sheetData.userId" class="dropdown">
                  <option value="0" class="hidden">Vælg bruger</option>
                  @for (user of users; track user) {
                    <option [value]="user.id">
                      {{ user.name }}
                    </option>
                  }
                </select>
              </div>
            </div>
            <div class="dialogFooter">
              <app-save-button
            [disabled]="
              !sheetData.sheetName || !sheetData.sheetId || !sheetData.userId
            "
                [clickEvent]="saveChanges.bind(this)"
                >
              </app-save-button>
              @if (
                userService.getSelectedRole == userService.getUserRoleTypes.Admin
                ) {
                <app-delete-button
                  [clickEvent]="deleteSheet.bind(this)"
                  >
                </app-delete-button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  }
